import { Component, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';

@Component({
  standalone: false,
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  
  langData: any;
  model;
  
  constructor( public app: AppComponent ) { }

  ngOnInit() {
  }

}
